import RelatedJobCard from "../../../Molecules/RelatedJobCard";

export default function RelatedJobs({ relatedJobs }) {
  if (relatedJobs.length === 0) return null;

  return (
    <section className="bg-light-brand py-16">
      <div className="containers-min mx-auto px-4 ">
        <h2 className="text-2xl font-bold mb-6">Related Jobs</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {relatedJobs.map((j) => <RelatedJobCard job={j} key={j.id} />)}
        </div>
      </div>
    </section>
  );
}
